import React, { createContext, useState } from "react";
import Cookies from "js-cookie";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Read token from cookie on first render
  const [authToken, setAuthToken] = useState(
    () => Cookies.get("authUser") || null
  );

  const login = (token) => {
    Cookies.set("authUser", token);
    setAuthToken(token);
  };

  const logout = () => {
    Cookies.remove("authUser");
    Cookies.remove("email");
    Cookies.remove("role_id");
    Cookies.remove("user_id");
    Cookies.remove("username");

    setAuthToken(null);
  };

  return (
    <AuthContext.Provider value={{ authToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};